import React from "react";
import { useI18n } from "../lib/i18n";
import { Link } from "react-router-dom";

export default function Navbar() {
  const { t, lang, setLang } = useI18n();
  const nav = [
    { id: "about", label: t.nav.about },
    { id: "services", label: t.nav.services },
    { id: "portfolio", label: t.nav.portfolio },
    { id: "contact", label: t.nav.contact },
  ];
  return (
    <header className="fixed top-0 left-0 right-0 z-50" data-testid="site-navbar">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 py-4">
        <div className="glass rounded-full px-4 sm:px-6 py-3 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
            <span className="text-cyan text-lg font-heading font-bold gold-glow" style={{color: "var(--gold)"}}>◆</span>
            <span className="font-heading font-bold tracking-wide text-sm sm:text-base">ARVEX</span>
          </Link>
          <nav className="hidden md:flex items-center gap-6">
            {nav.map((n) => (
              <a key={n.id} href={`#${n.id}`} className="text-sm text-gray-300 hover:text-[color:var(--gold)] transition-colors" data-testid={`nav-${n.id}-link`}>
                {n.label}
              </a>
            ))}
          </nav>
          <div className="flex items-center gap-1 sm:gap-2">
            {["RU", "EN", "CN"].map((L) => (
              <button
                key={L}
                data-testid={`lang-${L.toLowerCase()}`}
                onClick={() => setLang(L.toLowerCase())}
                className={`lang-btn ${lang === L.toLowerCase() ? "active" : ""}`}>
                {L}
              </button>
            ))}
            <Link to="/admin" className="btn-outline hidden sm:inline-flex ml-2 !py-2 !px-4 text-xs" data-testid="nav-admin-link">
              {t.nav.admin}
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}
